var repListingTemplate = _.template( document.getElementById( 'rep-listing-template' ).innerHTML );
export {repListingTemplate};